module.exports = __webpack_public_path__ + "ff23870c08a6071b40c26134b4148289.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/urbaterra.png
// module id = 629
// module chunks = 0